export enum KamiCameraType {
  Mav,
  Axis,
  Hik,
  Jenoptik,
  Mobotix,
  Arvoo,
  CitySync
}